var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrustpilotRatings2StarRgb = function SvgTrustpilotRatings2StarRgb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 18,
    viewBox: "0 0 97 18"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_2star-RGB_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.023.012H19V18H1.023Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_2star-RGB_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 .012h19V18H20Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_2star-RGB_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 .012h19V18H39Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_2star-RGB_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 .012h18V18H59Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_2star-RGB_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78 .012h18.32V18H78Zm0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_2star-RGB_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e1e1e",
      fillOpacity: 1
    },
    d: "M18.89.012H1.024v18h17.868Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_2star-RGB_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e1e1e",
      fillOpacity: 1
    },
    d: "M38.246.012H20.38v18h17.867Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_2star-RGB_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#dcdce6",
      fillOpacity: 1
    },
    d: "M57.605.012H39.738v18h17.867Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_2star-RGB_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#dcdce6",
      fillOpacity: 1
    },
    d: "M76.96.012H59.095v18H76.96Zm0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_2star-RGB_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#dcdce6",
      fillOpacity: 1
    },
    d: "M96.32.012H78.453v18H96.32Zm0 0"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "m9.957 12.145 2.715-.696 1.137 3.528Zm6.254-4.56h-4.785L9.957 3.052 8.484 7.586h-4.78l3.87 2.812-1.472 4.54 3.875-2.813 2.378-1.727ZM29.313 12.145l2.718-.696 1.137 3.528Zm6.253-4.56h-4.78l-1.474-4.534-1.468 4.535h-4.785l3.87 2.812-1.468 4.54 3.871-2.813 2.383-1.727ZM48.672 12.145l2.719-.696 1.132 3.528Zm6.254-4.56H50.14l-1.47-4.534L47.2 7.586h-4.781l3.871 2.812-1.473 4.54 3.875-2.813 2.383-1.727ZM68.027 12.145l2.72-.696 1.136 3.528Zm6.254-4.56H69.5l-1.473-4.534-1.468 4.535h-4.786l3.872 2.812-1.47 4.54 3.872-2.813 2.383-1.727ZM87.387 12.145l2.718-.696 1.133 3.528Zm6.254-4.56h-4.786l-1.468-4.534-1.473 4.535h-4.781l3.87 2.812-1.468 4.54 3.871-2.813 2.383-1.727Zm0 0"
  }));
};
export default SvgTrustpilotRatings2StarRgb;